"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grammar = void 0;
exports.grammar = `
{{
  function getOperation(op) {
    switch (op) {
      case "==":
        return "EQ"
      case "?=":
        return "CONTAINS"
      case "&&":
        return "AND"
      case "||":
        return "OR"
    }
  }
}}

Expression
  = _ head:Condition tail:(_ ("&&" / "||") _ Condition)* _
  {
    let result;
    
     if (tail.length) {
      let operation = getOperation(tail[0][1]);

      result = {
        operation,
          filters: [
            head,
          ]
      }
            
      for (let i = 0; i < tail.length; i++) {
        if (operation !== getOperation(tail[i][1])) {
            error('Cannot have both AND / OR operations in single expression, use "(", ")" to prioritize.')
        }
        result.filters.push(tail[i][3])
      }
        
      return result;
    }
    
    return {
      ...head
    }
  }

Condition
  = "(" expr:Expression ")" { return expr; } / Filter
  
Filter
  = field:Field _ operation:("==" / "?=") _ value:Value
  {
    return { field, operation: getOperation(operation), value }
  }

Field "field"
  = [abcdefghijklmnopqrstuvxyzABCDEFGHIJKLMNOUQRSTUVWXYZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚÝŽ\\.\\/ ]i* { return text(); }

Value "value"
  = [abcdefghijklmnopqrstuvxyzABCDEFGHIJKLMNOUQRSTUVWXYZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚÝŽ0-9\\.\\/\\- ]i* { return text(); }


_ "whitespace"
  = [ \\\t\\\n\\\r]*
`;
/**
 * Backup
 */
// Field "field"
//   = _ [a-z\\.\\/ ]i+ { return text().trim(); }
// Value "value"
//   = _ [a-z0-9\\.\\/ ]i+ { return text().trim(); }
//# sourceMappingURL=grammar.js.map